import React from "react";
import SVG from "react-inlinesvg";
import Instalogo from "@/src/media/social/Instagram.svg";
import Facebook from "@/src/media/social/facebook.svg";
import LinkedIn from "@/src/media/social/linkedin.svg";
import TikTok from "@/src/media/social/tiktok.svg";
import Twitter from "@/src/media/social/x-twitter.svg";
import Reddit from "@/src/media/social/reddit.svg";
import YouTube from "@/src/media/social/youtube.svg";
import { SmartLink } from "../../v2/SmartLink/SmartLink";

const Socials = () => {
    const socialNetworks = [
        { url: "https://www.instagram.com/getspotcovered", title: "Instagram", logo: Instalogo.src },
        { url: "https://www.facebook.com/getspotcovered", title: "Facebook", logo: Facebook.src },
        { url: "https://www.linkedin.com/company/spot-pet-insurance/", title: "LinkedIn", logo: LinkedIn.src },
        { url: "https://www.tiktok.com/@getspotcovered?lang=en", title: "TikTok", logo: TikTok.src },
        { url: "https://twitter.com/getspotcovered", title: "X", logo: Twitter.src },
        { url: "https://www.reddit.com/r/SpotPetInsurance/", title: "Reddit", logo: Reddit.src },
        { url: "https://www.youtube.com/@getspotcovered", title: "YouTube", logo: YouTube.src }
    ];
    return (
        <div className="flex items-center gap-2 text-accent-contrast">
            {socialNetworks.map(network => {
                const label = `Spot on ${network.title}`;
                // The fragment keeps the icon a direct child of the anchor (SmartLink wraps multiple children in a span).
                // The hidden text gives crawlers and screen readers real anchor text: the inline SVG renders nothing server-side (ENG-20489).
                return (
                    <SmartLink key={network.title} href={network.url} title={label} className="h-6 w-6">
                        <>
                            <SVG src={network.logo} />
                            <span className="sr-only">{label}</span>
                        </>
                    </SmartLink>
                );
            })}
        </div>
    );
};

export default Socials;
